import { useAuth } from '@/context/auth-context'
import ProviderSettingsPage from '@/pages/provider/ProviderSettingsPage'
import IndividualSettingsPage from '@/pages/IndividualSettingsPage'

export default function SettingsPage() {
  const { user } = useAuth()
  
  const isProvider = user?.userType === 'provider'
  
  if (isProvider) {
    return <ProviderSettingsPage />
  }
  
  return <IndividualSettingsPage />
}
